import { Drawer } from "melco-ui";
import { useTranslation } from "react-i18next";
import { CancelLicenseForm } from "../../form/CancelLicenseForm";
import { Drawer as DrawerType, useGenericDrawer } from "../../../../hooks/drawer/useGenericDrawer";

type CancelLicenseDrawerProps = {
  drawer: DrawerType;
  licenseSerialNumberToCancel: string;
  licenseProductCode: string;
  onCloseDrawerCallBack: () => void
};

export const CancelLicenseDrawer: React.FC<CancelLicenseDrawerProps> = ({
  licenseSerialNumberToCancel,
  licenseProductCode,
  drawer,
  onCloseDrawerCallBack
}) => {
  const { t } = useTranslation();

  const referenceDrawer = useGenericDrawer()
  const { closeDrawer, isDrawerOpen } = drawer;

  const onCloseDrawerFn = () => {
    closeDrawer();
    onCloseDrawerCallBack();
  }

  return (

    <Drawer
      title={t("licenses.basic.detail.cancel.title")}
      placement="right"
      width={750}
      closable={true}
      onClose={closeDrawer}
      open={isDrawerOpen}
      bodyStyle={{ padding: '32px' }}
    >
      {isDrawerOpen && <CancelLicenseForm
        licenseProductCode={licenseProductCode}
        licenseSerialNumberToCancel={licenseSerialNumberToCancel}
        referenceDrawer={referenceDrawer}
        onCloseDrawer={onCloseDrawerFn}
      />}
    </Drawer>
  );
};
